export default "__VITE_ASSET__2fa0b487__"